import { useEffect, useState } from "react";
import { cloneDeep, isEmpty, map, range } from "lodash";
import { FieldArray, Formik, useFormikContext } from "formik";
import GoalTrackButton from "./GoalTrackButton";
import { Button, Col, Form, Row } from "react-bootstrap";
import { GOAL_TRACK_PARAMETERS } from "config/constants";
import { MinusBlackIcon, PlusBlackIcon } from "Assets/icons";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { CommonToolTip, RequiredFieldAstrick } from "components/Common/Common";

const GoalTrackingForm = ({ saveGoalTrackings, index, isLoading, disabled }) => {

  const { values, setFieldValue } = useFormikContext();
  return (
    <div>
      {!values?.clientData[index]?.goalTracking?.some(x => x.tracked) && <h6 style={{ color: "#f27e97", marginBottom: "-10px" }}></h6>}
      <FieldArray name={`clientData[${index}].goalTracking`}>
        {({ insert, remove, push }) => (
          <div className="py-2">
            <div
              className="cardCstm rounded-3"
              style={{
                background: "#F7F0F5",
              }}
            >
              <div className="top px-3 py-2 d-flex align-items-center justify-content-between border-bottom">
                <div className="d-flex align-items-center">
                  <h6
                    style={{ fontSize: 14 }}
                    className="m-0 fw-bold text-uppercase"
                  >
                    Total Tracked
                  </h6>
                </div>
                {/* <CommonToolTip
                  text="Lorem Ipsum Dolor Sit Amet"
                  component={
                    <Button
                      className="border-0 p-0"
                      variant="transparent"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M9 18C10.78 18 12.5201 17.4722 14.0001 16.4832C15.4802 15.4943 16.6337 14.0887 17.3149 12.4442C17.9961 10.7996 18.1743 8.99002 17.8271 7.24419C17.4798 5.49836 16.6226 3.89471 15.364 2.63604C14.1053 1.37737 12.5016 0.520203 10.7558 0.172936C9.00998 -0.17433 7.20038 0.00389957 5.55585 0.685088C3.91131 1.36628 2.50571 2.51983 1.51677 3.99987C0.527841 5.47991 0 7.21997 0 9C0.00258081 11.3862 0.951621 13.6738 2.63889 15.3611C4.32616 17.0484 6.61384 17.9974 9 18ZM9 3.75C9.2225 3.75 9.44001 3.81598 9.62501 3.9396C9.81002 4.06322 9.95421 4.23892 10.0394 4.44448C10.1245 4.65005 10.1468 4.87625 10.1034 5.09448C10.06 5.31271 9.95283 5.51316 9.79549 5.6705C9.63816 5.82783 9.4377 5.93498 9.21948 5.97839C9.00125 6.02179 8.77505 5.99952 8.56948 5.91437C8.36391 5.82922 8.18821 5.68502 8.0646 5.50002C7.94098 5.31501 7.875 5.09751 7.875 4.875C7.875 4.57663 7.99352 4.29049 8.2045 4.07951C8.41548 3.86853 8.70163 3.75 9 3.75ZM8.25 7.5H9C9.39782 7.5 9.77935 7.65804 10.0607 7.93934C10.342 8.22065 10.5 8.60218 10.5 9V13.5C10.5 13.6989 10.421 13.8897 10.2803 14.0303C10.1397 14.171 9.94891 14.25 9.75 14.25C9.55109 14.25 9.36032 14.171 9.21967 14.0303C9.07902 13.8897 9 13.6989 9 13.5V9H8.25C8.05109 9 7.86032 8.92099 7.71967 8.78033C7.57902 8.63968 7.5 8.44891 7.5 8.25C7.5 8.05109 7.57902 7.86032 7.71967 7.71967C7.86032 7.57902 8.05109 7.5 8.25 7.5Z"
                          fill="#3DA0AA"
                        />
                      </svg>
                    </Button>
                  }
                /> */}
              </div>
              <div className="contentBody pb-3">
                <ul className="list-unstyled ps-0 mb-0">
                  {values?.clientData[index]?.goalTracking?.length > 0 &&
                    values?.clientData[index]?.goalTracking.map((tracking, trackingIndex) => {
                      const handleGoalTrackClick = (element) => {
                        const goalTrackingClone = cloneDeep(values?.clientData[index]?.goalTracking || []);
                        const existingRow = goalTrackingClone[trackingIndex];

                        existingRow.tracked = element;

                        setFieldValue(`clientData[${index}].goalTracking`, goalTrackingClone);
                      };

                      const handleRemove = () => {
                          remove(trackingIndex);
                      };

                      return (
                        <li key={trackingIndex} className="border-bottom">
                          <Row className="w-100">
                            <Col lg={11} className="py-2">
                              <ul
                                className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-between position-relative gap-10 ratingList"
                                style={{ zIndex: 9 }}
                              >
                                {Object.keys(GOAL_TRACK_PARAMETERS).map((element) => (
                                  <li key={element} className="px-2">
                                    <GoalTrackButton
                                      element={element}
                                      selected={tracking?.tracked === element}
                                      onClick={() => handleGoalTrackClick(element)}
                                      disabled={disabled}
                                    />
                                  </li>
                                ))}
                              </ul>
                            </Col>
                            <Col
                              lg={1}
                              className="d-flex align-items-center justify-content-end p-0 gap-10"
                            >
                              {trackingIndex !== 0 && values?.clientData[index]?.goalTracking.length > 1 ? (
                                <Button
                                  className="p-0 border-0"
                                  variant="transparent"
                                  size="sm"
                                  onClick={handleRemove}
                                  disabled={disabled}
                                >
                                  <MinusBlackIcon /> 
                                </Button>
                              ) : (
                                trackingIndex === 0 && (
                                  <Button
                                    className="p-0 border-0"
                                    variant="transparent"
                                    size="sm"
                                    onClick={() => push({ })}
                                    disabled={disabled}
                                  >
                                    <PlusBlackIcon />
                                  </Button>
                                )
                              )}
                            </Col>
                          </Row>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
          </div>
        )}
      </FieldArray>
    </div>
  )
}


export default GoalTrackingForm;